"use client"

import { ToastContainer, Slide } from "react-toastify";

interface ToastProviderProps {
    children: React.ReactNode;
}

export default function ToastProvider ({ children }: ToastProviderProps) {
    return(
        <>
            {children}
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={true}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={true}
                theme="light"
                transition={Slide}
                style={{width:"90vw"}}
            />
        </>
    );
}